import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import AuthGuard from "../../components/AuthGuard";
import Header from "../../components/Header";
import Backdrop from "../../components/Backdrop";
import { useDispatch, useSelector } from "react-redux";
import Confetti from "../../components/Confetti/Confetti";
import { Suspense, memo, useEffect } from "react";
import { login, logout } from "../../data/slices/authSlice";
import { useLTICheck } from "../../hooks/useLTICheck";

const MainLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { user } = useSelector((state) => state.auth);
  const searchParams = new URLSearchParams(document.location.search);
  const type = searchParams.get("type");
  // lti=1 strips the chrome (header + top padding) so an LTI VM launch
  // renders edge-to-edge inside the LMS iframe.
  const lti = searchParams.get("lti") === "1";

  useLTICheck();

  useEffect(() => {
    if (type === "demo" && user?.isDemo !== true) {
      dispatch(logout());
      dispatch(login({ username: "demo-account", password: "demo-account" }))
        .unwrap()
        .then(() => {
          navigate(`/?type=demo`);
        })
        .catch(() => {
          navigate("/not-found");
        });
    }
  }, [dispatch, type, user?.isDemo, navigate]);

  useEffect(() => {
    window.Fu?.showButton?.();
  }, [pathname]);

  return (
    <AuthGuard>
      <div className="main_layout">
        <Confetti time={3000} />
        <div className="main_layout__container">
          {!type && !lti && <Header isAdmin={false} />}
          <Suspense>
            <MainLayoutContent />
          </Suspense>
        </div>
        <Backdrop />
      </div>
    </AuthGuard>
  );
};

export default memo(MainLayout);

const MainLayoutContent = memo(() => {
  const searchParams = new URLSearchParams(document.location.search);
  const type = searchParams.get("type");
  const lti = searchParams.get("lti") === "1";

  const { mousePosition } = useSelector((state) => state.sessions);
  const { session } = useParams();
  const fullHeight = mousePosition >= 10 && document.fullscreenElement && session;
  return (
    <main
      style={{ paddingTop: !fullHeight && !lti ? "85px" : "0" }}
      className={`main_layout__container-content  ${
        type === "demo" || lti ? "main_layout__container-content-no-padding" : ""
      } `}
    >
      <Suspense>
        <Outlet />
      </Suspense>
    </main>
  );
});
